//@ts-ignore
import React from 'react';

import { t } from '@web-solutions/module-localization';
import {STATIC_TRANSLATIONS} from '../../../../../module-localization/constants/static';
import Analytics from '@web-solutions/module-analytics';

import { LinkButton, Button } from 'core/ui-elements';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { Theme } from 'core/constants/theme';
import { ProductDetails } from 'core/store/billing/selectors';
import { useThemeContext } from 'core/hooks/use-theme-context';
import { PayPalBtn } from 'core/payment/base/components/paypal';
import { type Subscription } from 'core/interfaces/billing';

import { Text } from 'core/ui-elements';

import { Image } from 'core/ui-elements';

import { Modal } from 'core/ui-elements/modal-new';

import { IMAGES } from './images';

import classes from './style.module.scss';
import { InsufficientFunds } from './components/302';
import { InvalidData } from './components/201-208-209';
import { PaymentAmountLimit } from './components/303';
import { SubscriptionLocked } from './components/214';
import { CardIssuer } from './components/003-306-403';
import { TokenNotFound } from './components/701';
import { CardIssuerWithImage } from './components/001-002-101-213-301-310-40x-501-602';
import { CardIssuerLaw } from './components/304-305-308-408-601';
import { CardBrandNotSupported } from './components/307';
import { CardIssuerInvalidFlow } from './components/211-212-309-502-503-508-707';
import { CardIssuerEmailFooter } from './components/2xx-5xx-7xx';
import { getContentByCode } from './utils/get-content-by-code';

const ERRORS_CONTENT = {
  insufficientFunds: InsufficientFunds,
  invalidData: InvalidData,
  paymentAmountLimit: PaymentAmountLimit,
  subscriptionLocked: SubscriptionLocked,
  cardIssuer: CardIssuer,
  tokenNotFound: TokenNotFound,
  cardIssuerWithImage: CardIssuerWithImage,
  cardIssuerLaw: CardIssuerLaw,
  cardBrandNotSupported: CardBrandNotSupported,
  cardIssuerInvalidFlow: CardIssuerInvalidFlow,
  cardIssuerEmailFooter: CardIssuerEmailFooter,
};

const images = {
  card: IMAGES.CARD_BG,
  billing: IMAGES.BILLING_BG,
};

const images_dark = {
  card: IMAGES.DARK_CARD_BG,
  billing: IMAGES.DARK_BILLING_BG,
};

type Props = {
  visible: boolean;
  product?: ProductDetails;
  onClose: (isPaypal?: boolean) => void;
  onSubmit: () => void;
  statusCode?: string | number;
  withStatusCode?: boolean;
  buttonTitle?: string;
  tKey?: string;
  onSkipClick?: () => void;
} & (
  | {
      withPayPal?: false;
    }
  | {
      withPayPal?: true;
      onPayPalSuccess: (p: Subscription) => void;
      onPayPalError: (e: any) => void;
      onPayPalSubmit: (formData: any) => void;
    }
);

const category = 'error_popup';

const ErrorPopup: React.FC<Props> = (props) => {
  const { visible, product, onClose, onSubmit, withPayPal, statusCode, onSkipClick } = props;

  const { errorPopup } = useRemoteConfig();
  const { theme } = useThemeContext();
  const isDark = theme === Theme.dark;

  const Component = ERRORS_CONTENT[getContentByCode(statusCode)];

  const handleClose = () => {
    onClose(withPayPal);
  };

  const handlePayPalSubmit = (formData: any) => {
    Analytics.trackEvent(category, 'payment_submit', { mode: 'paypal' });
    if (withPayPal) {
      props.onPayPalSubmit(formData);
    }
  };

  const handleSuccess = (p: Subscription) => {
    Analytics.trackEvent(category, 'payment_success', { mode: 'paypal' });
    if (withPayPal) {
      onClose();
      props.onPayPalSuccess(p);
    }
  };

  const handleError = (e: any) => {
    Analytics.trackEvent(category, 'payment_error', { mode: 'paypal' });
    if (withPayPal) {
      props.onPayPalError(e);
    }
  };

  return (
    <Modal visible={visible} onClose={handleClose} showClose>
      {errorPopup.isDetailedErrors && !withPayPal ? (
        <Component onClick={onSubmit} />
      ) : (
        <>
        <div className={classes.errorPopup}>
        <Image
            {...(isDark ? images_dark[errorPopup?.type] : images[errorPopup?.type])}
            className={classes.img}
            alt='background'
          />
          <Text className={classes.title} variant='h2'>
          {t('onboarding.upsaleThird.paymentFailed')}
          </Text>
          <Text className={classes.text} variant='p4'>
          {t('onboarding.upsaleThird.failedSubtitle')}
          </Text>
          <>
            <Button
              onClick={onSubmit}
              flare={false}
              iconRight={false}
              className={classes.button}
              title={t('onboarding.upsaleThird.retry')}
            />
            {visible && withPayPal && product && (
              <div className={classes.paypal_wrap}>
                <div className={classes.or}>{t('core.payment_popup.or')}</div>
                <div className={classes.paypal}>
                  <PayPalBtn
                    onSuccess={handleSuccess}
                    onError={handleError}
                    product={product}
                    onSubmit={handlePayPalSubmit}
                  />
                </div>
              </div>
            )}
            {onSkipClick && (
              <LinkButton
                className={classes.button}
                onClick={() => {
                  onSkipClick();
                  onClose();
                }}
              >
                <Text className={classes.buttonLater}>
                  {STATIC_TRANSLATIONS.errorPopup.buttonLater}
                </Text>
              </LinkButton>
            )}
                      </>

        </div>
          
        </>
      )}
    </Modal>
  );
};

export default ErrorPopup;
